import {createApp} from "vue";
import ScheduleApp from "../vue/Schedule.vue";
import {createI18n} from "vue-i18n";
import Language from "../vue/Helpers/Language";
import ptLang from '../../languages/pt.json';
import enLang from '../../languages/en.json';

const schedule = createApp(ScheduleApp);

schedule.use(createI18n({
    allowComposition: true,
    locale: Language.getLanguage(),
    fallbackLng: 'pt-BR',
    messages: {
        'pt-BR': ptLang,
        'en-US': enLang,
    }
}));

schedule.mount('#schedule');
